<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-10 16:54:08
 * @LastEditTime: 2020-06-19 14:53:58
 * @Description:
 -->
<template>
    <div class="left-menu show" id="leftMenu">
        <em class="close" id="close" @click="Open1"></em>
        <ul>
            <li v-for="(item, index) in tree" :key="index">
                <!-- <span
                    @click="clickHandler(index, item.id)"
                    :class="{ active: current === index }"
                    >{{ item.label }}<em class="icon"></em
                ></span> -->
                <span
                    @click="clickHandler(index, item.id)"
                    :class="{ active: current[index] }"
                    >{{ item.label }}<em class="icon"></em
                ></span>
                <transition name="fade">
                    <left-menu-item
                        :path="`/tools/${$route.meta.pid}/${item.id}`"
                        :items="item.children"
                        v-if="current[index]"
                    ></left-menu-item>
                </transition>
            </li>
        </ul>
    </div>
</template>

<script>
import leftMenuItem from "./left-menu-item";
export default {
    name: "LeftMenu",
    props: ["tree"],
    data() {
        return {
            current: {0: true}
        };
    },
    methods: {
        clickHandler(index, id) {
            this.$set(this.current, index, !this.current[index]);
            this.$router.push(`/tools/${this.$route.meta.pid}/${id}`);
        },
        Open1: function() {
            document.getElementById("leftMenu").setAttribute("class", "hide");
        }
    },
    components: {
        leftMenuItem
    }
};
</script>
<style lang="less" scoped>
* {
    list-style: none;
    text-decoration: none;
}
#leftMenu {
    width: 18%;
    height: calc(100vh - 80px);
    box-shadow: 5px 10px 30px 4px #d9deef;
    overflow-y: auto;
    background: #fff;
    ul {
        width: 100%;
        padding: 0;
        margin: 0;
        li {
            width: 100%;
            list-style: none;
            span {
                display: block;
                border-bottom: 1px solid #e0e2ef;
                padding: 1vw 0px 1vw 16%;
                cursor: pointer;
                font-size: 20px;
                font-weight: bold;
                color: #464646;
                line-height: 30px;
                &.active {
                    color: #214d98;
                }
                .icon {
                    width: 10px;
                    height: 15px;
                    background: url(../../../assets/front/icon-arrow.png) center
                        center no-repeat;
                    display: inline-block;
                    margin: 0px 0px 0px 10px;
                    position: relative;
                    top: 1px;
                }
                &.active .icon {
                    background: url(../../../assets/front/icon-arrow1.png)
                        center center no-repeat;
                }
            }
            &.active {
                span {
                    color: red;
                }
                dl {
                    display: block;
                }
            }
        }
    }
}

@media (max-width: 1024px) {
    #leftMenu {
        display: none;
        width: 50%;
        min-width: 150px;
        height: 100vh;
        position: absolute;
        top: 0px;
        right: 0px;
        background: #fff;
        box-shadow: 0px -5px 10px 3px #cccfd7;
        z-index:999999999999999;
        border-top:1px solid #e0e2ef;
        &.hide {
            display: none;
        }
        &.show {
            display: block;
        }
        ul {
            margin: 30px 0px 0px 0px;
            height: calc(100vh - 86px);
            overflow-y: auto;
            li {
                span {
                    font-size: 16px;
                    font-weight: normal;
                    color: #777777;
                    padding: 8px 10px 8px 15px;
                    .icon {
                        float: right;
                        position: relative;
                        top: 9px;
                    }
                }
                /deep/.left-menu-item {
                    dl {
                      margin:0;
                        dd {
                            margin:0px;
                            a {
                                font-size: 14px;
                                color: #777777;
                                padding: 10px 0px 10px 20px;
                                display: block;
                                border-bottom: 1px solid #e0e2ef;
                                &.router-link-active{
                                  color: #0a2581;
                                }
                            }
                        }
                    }
                }
            }
        }
        .close {
            width: 16px;
            height: 16px;
            background: url(../../../assets/front/icon-close.png) center center
                no-repeat;
            display: block;
            margin-top: 40px;
            background-size: cover;
            position: relative;
            left: 15px;
        }
    }
    .left-menu/deep/ ul li > div > dl > dd {
        border-bottom: 1px solid #e0e2ef;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/components/left-menu.vue